import { Link, useNavigate } from 'react-router';
import { useBadges } from '../../shared/badges';
import { useMe, useSession } from '../session/SessionProvider';
import { badgeFor, describeItems, HINTS, HUBS, hubItems, Icon, useBottomMenu, useNavGroups } from './nav';

/**
 * En celular: lo que no cabe en la barra inferior. Muestra las mismas secciones que el menú de la
 * computadora (Mi iglesia, Palabra, Comunidad…), y cada una abre su página de accesos.
 */
export function MorePage() {
  const { rest } = useBottomMenu();
  const groups = useNavGroups();
  const badges = useBadges(useMe());
  const { logout } = useSession();
  const navigate = useNavigate();
  return (
    <div className="page page--narrow">
      <header className="page__header">
        <h1>Más</h1>
      </header>
      <ul className="hub hub--single">
        {rest.map((item) => {
          // La descripción dice lo que esta persona sí ve en la sección, no la lista completa.
          const hub = HUBS.find((h) => h.to === item.to);
          const hint = hub
            ? describeItems(hubItems(groups, hub.title)) || hub.subtitle
            : (HINTS[item.to] ?? (item.to === '/app/perfil' ? 'Tus datos, tu familia y tu foto.' : null));
          const badge = badgeFor(item, badges);
          return (
            <li key={item.to}>
              <Link to={item.to} className="hub__item">
                <span className="hub__icon">
                  <Icon name={item.icon} />
                  {badge > 0 ? (
                    <span className="nav-badge nav-badge--dot" aria-label={`${badge} pendientes`}>
                      {badge}
                    </span>
                  ) : null}
                </span>
                <span>
                  <strong>{item.label}</strong>
                  {hint ? <span className="small muted">{hint}</span> : null}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="btn btn--ghost more__logout"
        onClick={async () => {
          await logout();
          navigate('/', { replace: true });
        }}
      >
        <Icon name="logout" /> Cerrar sesión
      </button>
    </div>
  );
}
